export default "__VITE_ASSET__BPZaZ$ja__"